module.exports = new __parcel__URL__("Food-Plaza.b8835a43.png").toString();